/** Compatibility export; the business domain owns this implementation. */
export { EnumFlyingDesignUploadPlatform, FlyingDesignUploadSchema, IFlyingDesignUpload } from '@domains/upload/shared';
